import React from 'react'
import clsx from 'clsx'

type Props = React.ComponentProps<'button'>

export const Prev = ({ className, ...props }: Props) => {
  return (
    <button className={clsx('swiper-button-prev', className)} {...props}>
      <svg
        width="15"
        height="22"
        viewBox="0 0 15 22"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
      >
        <path d="M10 6L5 11L10 16" stroke="currentColor" strokeWidth="1.5" />
      </svg>
    </button>
  )
}
